// src/components/SPanel/Home/homeActivity.js
//
// Calculele widget-urilor de activitate, din răspunsul GET
// /exams/practice/activity: o zi = { date "AAAA-LL-ZZ", answers, correct,
// wrong, learned }, toate zilele intervalului, ultima fiind azi.

const DAY_MS = 24 * 60 * 60 * 1000;

function parseDay(date) {
   const [y, m, d] = String(date).split("-").map(Number);
   return new Date(y, m - 1, d);
}

/**
 * Seria de zile la rând cu răspunsuri, până azi. Dacă azi încă n-a exersat,
 * seria de ieri ține până la sfârșitul zilei. `best` = cea mai lungă serie.
 */
export function streaks(days) {
   let best = 0;
   let run = 0;
   for (const day of days) {
      run = day.answers > 0 ? run + 1 : 0;
      best = Math.max(best, run);
   }
   let current = 0;
   let i = days.length - 1;
   if (i >= 0 && days[i].answers === 0) i -= 1; // azi încă nimic: contează de ieri
   for (; i >= 0 && days[i].answers > 0; i -= 1) current += 1;
   return { current, best };
}

export function activeDays(days) {
   return days.filter((day) => day.answers > 0).length;
}

export function sumDays(days) {
   return days.reduce(
      (acc, day) => ({
         answers: acc.answers + day.answers,
         correct: acc.correct + day.correct,
         wrong: acc.wrong + day.wrong,
         learned: acc.learned + day.learned,
      }),
      { answers: 0, correct: 0, wrong: 0, learned: 0 },
   );
}

/** Nivelul unei zile pe hartă: 0 (nimic) … 4 (cât cea mai activă zi). */
export function heatLevel(answers, max) {
   if (!answers || !max) return 0;
   return Math.min(4, Math.max(1, Math.ceil((4 * answers) / max)));
}

/**
 * Harta pe săptămâni: coloane luni → duminică, ultima coloană e săptămâna de
 * azi; zilele de după azi sunt `null`. Doar ultimele `weeks` săptămâni.
 */
export function weekColumns(days, weeks) {
   if (!days.length || weeks <= 0) return [];
   const byDate = new Map(days.map((day) => [day.date, day]));
   const today = parseDay(days[days.length - 1].date);
   const weekday = (today.getDay() + 6) % 7; // luni = 0
   const lastMonday = new Date(today.getTime() - weekday * DAY_MS);
   const columns = [];
   for (let w = weeks - 1; w >= 0; w -= 1) {
      const monday = new Date(lastMonday.getTime() - w * 7 * DAY_MS);
      const cells = [];
      for (let d = 0; d < 7; d += 1) {
         const date = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + d);
         if (date > today) {
            cells.push(null);
            continue;
         }
         const key = [
            date.getFullYear(),
            String(date.getMonth() + 1).padStart(2, "0"),
            String(date.getDate()).padStart(2, "0"),
         ].join("-");
         cells.push(byDate.get(key) || { date: key, answers: 0, correct: 0, wrong: 0, learned: 0 });
      }
      columns.push({ monday, cells });
   }
   return columns;
}

/** Întrebările învățate, cumulat, zi de zi (pornind de la cele de dinainte). */
export function learnedCurve(days, learnedBefore = 0) {
   let total = Math.max(0, Number(learnedBefore) || 0);
   return days.map((day) => {
      total += day.learned;
      return { date: day.date, total };
   });
}

/** O valoare „rotundă” deasupra maximului, pentru linia de ghidaj a graficului. */
export function niceMax(value) {
   if (value <= 0) return 10;
   const power = 10 ** Math.floor(Math.log10(value));
   const steps = [1, 2, 2.5, 5, 10];
   const step = steps.find((s) => s * power >= value) || 10;
   return step * power;
}

const WEEKDAYS = ["Lu", "Ma", "Mi", "Jo", "Vi", "Sâ", "Du"];

/** „Mi, 7 oct” */
export function formatShortDay(date) {
   const d = parseDay(date);
   const month = d
      .toLocaleDateString("ro-RO", { month: "short" })
      .replaceAll(".", "");
   return `${WEEKDAYS[(d.getDay() + 6) % 7]}, ${d.getDate()} ${month}`;
}

export function monthShort(date) {
   return date.toLocaleDateString("ro-RO", { month: "short" }).replaceAll(".", "");
}
